import type { ActionContext } from 'vuex';
import { getProviders } from '@/api/Providers';
import type { ProvidersState } from './ProvidersState';

export default {
  getProviders({
    commit,
    state
  }: ActionContext<ProvidersState, unknown>): void {
    getProviders().then((data) => {
      commit('setProviders', data);
    });
  }
};
